import React, { useEffect } from 'react';
import { Script } from 'gatsby';
import ImageView from 'src/components/ImageView';
import VideoPopup from 'src/components/VideoPopup';
import CookieBanner from 'src/components/CookieBanner';
import { animation } from 'src/utils';
import Footer from './Footer';
import Header from './Header';
import LayoutDataContextProvider from '../context/LayoutDataContext';

const Layout = ({ children, data }) => {
  useEffect(() => {
    animation();
  }, []);

  return (
    <LayoutDataContextProvider data={data}>
      {/* Font loading with Gatsby Script API - lazyOnload strategy */}
      <Script
        src="https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600;700;800&family=Raleway:wght@600;700;800&display=swap"
        strategy="lazyOnload"
      />
      <Script
        src="https://fonts.cdnfonts.com/css/stretch-pro"
        strategy="lazyOnload"
      />
      <Script
        src="https://fonts.cdnfonts.com/css/nexa-bold"
        strategy="lazyOnload"
      />
      <Script
        src="https://fonts.cdnfonts.com/css/made-outer-sans-alt"
        strategy="lazyOnload"
      />
      
      <VideoPopup />
      <ImageView />
      <div className="page-wrapper">
        <Header />
        {children}
        <Footer />
      </div>
      <CookieBanner />
    </LayoutDataContextProvider>
  );
};

export default Layout;
